import { ShowMoreButton } from "../../../components/ui/show-more-button";
import { useShowMore } from "../../../hooks/use-show-more";

/**
 * The questing-groups list with accumulating "Show more" paging (10 at a time).
 * The control first appears at the 11th group and reveals the next batch per
 * click. All paging is client-side — the full groups list is already loaded.
 *
 * Presentational: the parent supplies `renderCard(group)` (which must return a
 * keyed element) so this component stays decoupled from GroupCard's large prop
 * surface, and owns the empty state itself (this returns null when empty).
 */
export function GroupsListSection({ groups, renderCard, step, itemNoun = "group" }) {
  const list = Array.isArray(groups) ? groups : [];
  const showMore = useShowMore(list, step ? { step } : undefined);

  if (list.length === 0) return null;

  return (
    <div>
      <div className="space-y-4">
        {showMore.visibleItems.map((group) => renderCard(group))}
      </div>
      {/* Persistent live region: announces each reveal to screen readers even
          after the button unmounts on the terminal click (PaginationFooter uses
          the same aria-live approach for its range text). */}
      <p className="sr-only" role="status" aria-live="polite">
        Showing {showMore.shownCount} of {showMore.total} {itemNoun}
        {showMore.total === 1 ? "" : "s"}
      </p>
      <ShowMoreButton
        hasMore={showMore.hasMore}
        remaining={showMore.remaining}
        step={showMore.step}
        onClick={showMore.showMore}
        itemNoun={itemNoun}
      />
    </div>
  );
}
